type ResultsType = Record<
  string,
  {
    value: unknown;
    success: boolean;
  }
>;
type FetchCache = {
  awaitingKeys: string[];
  results: ResultsType;
};
declare global {
  interface Window {
    fetchCache: FetchCache;
  }
}

export class RestLocalCache {
  static instance: RestLocalCache;

  private getInitialStore(): {
    results: ResultsType;
    awaitingKeys: string[];
  } {
    return {
      results: {},
      awaitingKeys: [],
    };
  }

  static getInstance(): RestLocalCache {
    if (!RestLocalCache.instance) {
      RestLocalCache.instance = new RestLocalCache();

      if (typeof window !== "undefined" && !window.fetchCache) {
        window.fetchCache = RestLocalCache.instance.getInitialStore();
      }
    }

    return RestLocalCache.instance;
  }

  registerAction(key: string): void {
    window.fetchCache.awaitingKeys.push(key);
  }

  unregisterAction(key: string): void {
    window.fetchCache.awaitingKeys = window.fetchCache.awaitingKeys.filter((item) => item !== key);
  }

  setValue(key: string, value: unknown, success = true): void {
    window.fetchCache.results[key] = {
      value,
      success,
    };
    window.fetchCache.awaitingKeys = window.fetchCache.awaitingKeys.filter((currentKey) => currentKey !== key);
  }

  getValue<T>(
    key: string,
    onError: (resolve: (data: T | any) => void, reject: (data?: unknown) => void) => void
  ): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      const interval = setInterval(() => {
        if (window.fetchCache.awaitingKeys.indexOf(key) === -1) {
          const currentValue = window.fetchCache.results[key];
          clearInterval(interval);

          if (!currentValue) {
            return onError(resolve, reject);
          }

          if (currentValue.success) {
            resolve(currentValue.value as T);
          } else {
            reject(currentValue.value as T);
          }
        }
      }, 100);
    });
  }

  hasValue(key: string): boolean {
    return window.fetchCache.awaitingKeys.indexOf(key) > -1 || !!window.fetchCache.results[key];
  }

  clear(): void {
    window.fetchCache = this.getInitialStore();
  }
}
